export default [
  "UTC",
  "Europe/Warsaw",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Lisbon",

  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",

  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Asia/Shanghai",

  "Australia/Sydney"
]
